import { RightOutlined } from '@ant-design/icons';
import { Flex, List, Space, Typography } from 'antd';

import { OnboardingAction } from './actions-list.model';
import * as Styled from './actions-list.style';

const { Text } = Typography;

interface ActionsListProps {
  actions: OnboardingAction[];
}

const ActionsList = ({ actions }: ActionsListProps) => {
  const handleActionClick = (actionId: string) => {
    const action = actions.find((a) => a.id === actionId);
    action?.onClick();
  };

  return (
    <List
      dataSource={actions}
      renderItem={(action) => (
        <List.Item
          key={action.id}
          onClick={() => handleActionClick(action.id)}
          style={{ cursor: 'pointer', paddingRight: 0 }}
        >
          <Flex
            align="center"
            justify="space-between"
            style={{ width: '100%' }}
          >
            <Space>
              <Styled.ActionIcon>{action.icon}</Styled.ActionIcon>
              <Text>{action.label}</Text>
            </Space>
            <Styled.ActionArrow>
              <RightOutlined />
            </Styled.ActionArrow>
          </Flex>
        </List.Item>
      )}
    />
  );
};

export { ActionsList };
